import { render, staticRenderFns } from "./provider-games.vue?vue&type=template&id=20339b40&"
import script from "./provider-games.vue?vue&type=script&lang=js&"
export * from "./provider-games.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports